import React, { useEffect } from 'react'
import { useState } from 'react'
import { module as user } from "@st/user";
import { connectStore } from "redux-box";
import { module as onboard } from "@st/onboard";
import { module as ui } from "@st/ui";

import './AssignFreadomTeacher.css'
import { ThemeButton } from '../../../../static/styled/custom.styled';
import Select from 'react-select'


const AssignFreadomTeacher = (props) => {

  const [section,setSection] = useState([])
  const [sectionsList,setSectionsList] = useState([])
  const [classType, setClassType] = useState({ label: 'FFS', value: 'FFS' })

  const classTypeOptions = [
    { label: 'FFS', value: 'FFS' },
    { label: 'WOW', value: 'WOW' },
    { label: 'Both', value: 'BOTH' }
  ]

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      position: "relative"
    }),
  };

  useEffect(()=>{
    let schoolclassList=[]
    if(props.user.active_child){
      const teacherId = props.user.active_child.teacher;
      let difference = props.user.active_child.school_class.filter((sc) => {
        if (classType.value === 'FFS') return sc.teacher !== teacherId;
        if (classType.value === 'WOW') return sc.wow_teacher !== teacherId;
        if (classType.value === 'BOTH') return sc.teacher !== teacherId || sc.wow_teacher !== teacherId;
        return true;
      });

        if(difference.length>0){
          difference.forEach((sc)=>{
            schoolclassList.push({
              label:sc.name,
              value:sc.id
            })
      })
    }else{
      props.user.active_child.school_class.forEach((sc)=>{
        schoolclassList.push({
          label: sc.name,
          value: sc.id
        })
      })
    }
      setSectionsList(schoolclassList)
    }
  },[props.user.active_child, classType])


  const handleAssignFreadomTeacher = async() => {
    if (section.length === 0) {
      alert("Please select at least one section")
      return
    }
    const data = {
      is_freadom_teacher: true,
      child: props.user.active_child.id,
      school_class:section.map((sec)=>sec.value),
      class_type: classType.value
    }
    await props.user.updateFreadomTeacher(data)
    props.ui.hideModal()
  }
  return (
    <div className='link_school_code_form'>

        <React.Fragment>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Class Type</label>
            <Select
              className="dropdown-container"
              value={classType}
              onChange={(selected) => {
                setClassType(selected)
                setSection([]) // Reset sections when type changes
              }}
              options={classTypeOptions}
              placeholder="Select Class Type"
              styles={customStyles}
            />
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ fontSize: '14px', marginBottom: '5px', display: 'block' }}>Sections</label>
            <Select
              className="dropdown-container"
              isMulti = {true}
              value={section}
              onChange={(selectedSection) =>
                setSection(selectedSection)
              }
              options={sectionsList && sectionsList}
              placeholder="Select Section"
              styles={customStyles}
            />
          </div>

          <ThemeButton primary onClick={() => handleAssignFreadomTeacher()}
            type="button" className="link_school_code_form_btn">Assign as Teacher</ThemeButton>
        </React.Fragment>

    </div>
  )
}

export default connectStore({
  user,
  onboard,
  ui
})(AssignFreadomTeacher);